export enum DeviationTypeEnum {
    Positive = 'Positive',
    Negative = 'Negative',
    ZeroActivity = 'ZeroActivity'
}
